module.exports = "https://tutorchat.chegg.com/static/media/ic-star-default.242b611b.svg";